<!--title -->
<app-modal-title [title]="formPageConfig.title|translate" [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="row tw-w-[350px] m-0">
      <!-- amount -->
      <div class="md:tw-w-full tw-w-full tw-px-0">
        <form-field
          [(value)]="model.amount"
          [hasCurrency]="true"
          type="tel"
          [hasNumberSeparator]="true"
          [control]="form?.get('amount')"
          [label]="'common.organizationCredit'"
        >
        </form-field>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
